import React from "react";
import './contact.css';
import HeaderComponent from "../header/header";
import NavbarComponent from "../header/top.navbar";
import FooterComponent from "../footer/footer";
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaUserTie, FaUser } from 'react-icons/fa';
import { Helmet } from "react-helmet-async";
// import gampalaviswamImage from "../../assets/images/Director.jpg";
// import vengadarajanImage from "../../assets/images/Vengadrajan.jpg";
// import meeradasImage from "../../assets/images/MeeraDas.jpg";
// import ashutoshKedarImage from "../../assets/images/AshutoshKedar.jpg";
// import saleemImage from "../../assets/images/Saleem.jpg";
// import sushmaImage from "../../assets/images/SushmaBR.jpg";
// import anandsaivermaImage from "../../assets/images/AnandSaiVerma.jpg";
// import somsingrathodImage from "../../assets/images/SomsingRathod.jpg";


const ContactFormComponent = () => {
  //   const teamMembers = [
  //     {
  //       name: "Shri. Gampala Viswam",
  //       role: "President",
  //       email: "visgam@gmail.com",
  //       phone: "+91 XXXXX XXXXX",
  //       icon: <FaUserTie />,
  //       image: gampalaviswamImage
  //     },
  //     {
  //       name: "Dr. A Vengadarajan",
  //       role: "Vice President",
  //       email: "vengadaranjan@gmail.com",
  //       phone: "+91 XXXXX XXXXX",
  //       icon: <FaUserTie />,
  //       image: vengadarajanImage
  //     },
  //     {
  //       name: "Smt. Meera Das",
  //       role: "Council Member",
  //       email: "meeraDas@gmail.com",
  //       phone: "+91 XXXXX XXXXX",
  //       icon: <FaUser />,
  //       image: meeradasImage
  //     },
  //     {
  //       name: "Dr. Ashutosh Kedar",
  //       role: "Council Member",
  //       email: "ashutosh.kedar@ieee.org",
  //       phone: "+91 XXXXX XXXXX",
  //       icon: <FaUser />,
  //       image: ashutoshKedarImage
  //     },
  //     {
  //       name: "Shri. Saleem Javeed",
  //       role: "Council Member",
  //       email: "saleemJaveed@gmail.com",
  //       phone: "+91 XXXXX XXXXX",
  //       icon: <FaUser />,
  //       image: saleemImage
  //     },
  //     {
  //       name: "Smt. Sushma BR",
  //       role: "Council Member",
  //       email: "sushma@gmail.com",
  //       phone: "+91 XXXXX XXXXX",
  //       icon: <FaUser />,
  //       image: sushmaImage
  //     },
  //     {
  //       name: "Shri. Anand Sai Verma",
  //       role: "Treasurer",
  //       email: "anandsaiverma@gmail.com",
  //       phone: "+91 XXXXX XXXXX",
  //       icon: <FaIdCard />,
  //       image: anandsaivermaImage
  //     },
  //     {
  //       name: "Dr. Somsing Rathod",
  //       role: "General Secretary",
  //       email: "somurathod@gmail.com",
  //       phone: "+91 9880107412",
  //       icon: <FaIdCard />,
  //       image: somsingrathodImage
  //     }
  //   ];

  return (
    <>
      <Helmet>
        <title>CONTACT SMARTFORUM - Society for Microwaves, Antennas and Radar Technologies</title>
        <meta name="description" content="Join SMART, a technology-driven community shaping the future of innovation, research, and collaboration." />
        <meta name="robots" content="index, follow" />
      </Helmet>
      <HeaderComponent />
      <NavbarComponent />
      <section id="fixed-sub-nav" className="gradient-background" style={{ paddingBottom: '30px', paddingTop: '30px' }}>

        <div className="container text-center py-5">
          <h1 className="display-5 fw-bold">Contact Us</h1>
          <p className="lead">
            We're here to help. Whether you have questions about our services, support needs, or anything else,
            our team is ready to answer all your questions.
          </p>
        </div>

        {/* Contact Info Section */}
        <div className="container mb-5">
          <div className="row g-4 text-center">
            <div className="col-md-3">
              <div className="p-4 border rounded bg-white shadow-lg h-100">
                <FaUserTie size={28} className="mb-2 text-primary" />
                <h5>Name</h5>
                <p className="mb-0 text-center">General Secretary, SMART</p>
              </div>
            </div>
            <div className="col-md-3">
              <div className="p-4 border rounded bg-white shadow-lg h-100">
                <FaPhone size={28} className="mb-2 text-primary" />
                <h5>Phone</h5>
                <p className="mb-0 text-center">+91 9880107412</p>
              </div>
            </div>
            <div className="col-md-3">
              <div className="p-4 border rounded bg-white shadow-lg h-100">
                <FaEnvelope size={28} className="mb-2 text-primary" />
                <h5>Email</h5>
                <p className="mb-0 text-center">smartforum2025@gmail.com</p>
              </div>
            </div>
            <div className="col-md-3">
              <div className="p-4 border rounded bg-white shadow-lg h-100">
                <FaMapMarkerAlt size={28} className="mb-2 text-primary" />
                <h5>Office</h5>
                <p className="mb-0 text-center">C V Raman Nagar, Bengaluru, Karnataka, India. Pin- 560093</p>
              </div>
            </div>
          </div>
        </div>

        {/* Support Team Section */}
        <div className="container text-center mb-5">
          <h4 className="mb-4">Meet Our Support Team</h4>
          <div className="row g-4 justify-content-center">
            <div className="col-sm-6 col-md-4">
              <div className="p-4 border rounded bg-white shadow-lg h-100">
                <FaUserTie size={40} className="text-primary mb-3" />
                 <h6>vengadarajan@yahoo.com</h6>
                 <small>Industry / Academia Collaboration</small>
                {/* <p className="text-center">Chairperson – Industry / Academia Collaboration</p> */}
              </div>
            </div>
            <div className="col-sm-6 col-md-4">
              <div className="p-4 border rounded bg-white shadow-lg h-100">
                <FaUserTie size={40} className="text-primary mb-3" />
                <h6>ashutosh.kedar@ieee.org</h6>
                <small>Technical Assistance Manager</small>
              </div>
            </div>
          </div>
        </div>

      </section>
      <FooterComponent />
    </>
  );
};

export default ContactFormComponent;





